import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetLBOfflineRefNo } from '$Deposits/store/actions/DepositAction'

const OfflineRefNoBank = ['SAC']
const refNoTips = {
    VCB: {
        text: 'Vui lòng điền Mã số tham chiếu gồm 16 chữ số được cung cấp từ ngân hàng cho lệnh giao dịch thành công. Ví dụ 20xxxxxxxxxxxxxx',
        maxLength: 16
    },
    SAC:{
        text: 'Vui lòng điền mã số tham chiếu được cung cấp bởi ngân hàng sau khi chuyển tiền để giao dịch được thực hiện thành công',
        maxLength: 30
    },
    TEC: {
        text: 'Vui lòng điền Mã số bút toán được cung cấp từ ngân hàng cho lệnh giao dịch thành công.Ví dụ : FT/xxxxx/xxxxxxxxx',
        maxLength: 18
    }
}
class LBOfflineRefNo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            LBOfflineRefNo,
            RefNoInput,
            SetLBOfflineRefNo,
            DepositBankActive,
        } = this.props;
        const { bankCode } = DepositBankActive
        const { refNo, refNoErrMsg } = LBOfflineRefNo || {}

        const isShow = OfflineRefNoBank.some(v => v == bankCode) || false

        return (
            <>
                {
                    isShow &&
                    <RefNoInput
                        title={'Số Tham Chiếu'}
                        stateVal={refNoErrMsg}
                        value={refNo}
                        placeholder={''}
                        maxLength={refNoTips[bankCode].maxLength}
                        onChange={(value) => { SetLBOfflineRefNo(value, bankCode) }}
                        tips={refNoTips[bankCode].text}
                        keyboardType={bankCode == 'VCB' ? 'number-pad' : 'default'}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositBankActive: state.DepositBankActive,
    LBOfflineRefNo: state.LBOfflineRefNo,
});
const mapDispatchToProps = {
    SetLBOfflineRefNo: (data = '', bankCode, isRefresh) => SetLBOfflineRefNo(data, bankCode, isRefresh),
};
export default connect(mapStateToProps, mapDispatchToProps)(LBOfflineRefNo);


